import React, { useCallback, useEffect, useMemo, useState,useRef, useContext } from 'react'; 
// import HomeContent from './Draw' 
import useDelayShow from '../../hooks/useDelayShow'; 
import Page from '../../components/Page';
import { StyledTopBar, StyledTopBarInner } from '../../components/TopBar/TopBar';
import Container from '../../components/Container';
import { LeftOutlined } from '@ant-design/icons';
import { useParams } from 'react-router';
import { useNews } from '../../hooks/useNews';
import moment from 'moment';
import Spacer from '../../components/Spacer';
import { Spin } from 'antd';

const Home: React.FC = () => { 
  const {id} = useParams<{id:string}>()
  const articles = useNews(id)
  return <Page>
     <StyledTopBar>
        <Container size="lg">
          <StyledTopBarInner>
            <div style={{width:50,marginLeft:10}}>
              <LeftOutlined onClick={()=>{
                // history.goBack()
                window.close()
              }}/>
            </div>
            <div>{articles?.[0]?.title}</div>
            <div style={{color:'white',width:50,marginRight:10}}></div>
          </StyledTopBarInner>
        </Container>
      </StyledTopBar>
      <Spacer size='lg'/>
      <Spacer size='sm'/>
      {!articles &&  <Spin/>}
      {/* {articles?.length===0 &&} */}
      {articles?.length > 0 &&<>
      <span style={{fontSize:20,fontWeight:'bold',alignSelf:'flex-start',marginLeft:10}}>{articles?.[0]?.title}</span>
      <span style={{fontSize:14,alignSelf:'flex-start',marginLeft:10}}>{moment(new Date(articles?.[0]?.time)).format('YYYY-MM-DD HH:mm:ss')}</span>
      <div style={{width:'calc( 100% - 20px)',marginTop:10,position:'relative'}}>
        <div dangerouslySetInnerHTML={{__html:articles?.[0]?.content}}>
        </div>
      </div>
      </>}
    </Page>
};
 

export default Home;
